import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { StylesTable } from '../components';

export const StylesPage: FC = () => {
  const navigate = useNavigate();

  const redirectToStyleDetails = (item) => {
    navigate(Routes.StyleDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="Styles"
        actions={[
          <Link
            to={Routes.NewStyle}
            key="new-style"
            data-testid="add-new-style-link"
          >
            <Button data-testid="add-new-model-button">
              <PlusSquareIcon />
              Add new style
            </Button>
          </Link>,
        ]}
      />

      <StylesTable onClick={redirectToStyleDetails} />
    </div>
  );
};
